import React from 'react';
import axios from 'axios';
import cookie from 'react-cookies';

const axiosConfig = () => {
  // console.warn('目前请求的是本地的ajax');
  const token = cookie.load('token') || '';
  const request = axios.create({
    // baseURL: 'http://localhost:3001',
    // baseURL: 'https://spmi.bluewebonline.com',
  });
  request.interceptors.request.use(
    function (config) {

      // console.error('现在请求的是dev的');
      // config.url = config.url.replace('/api/', '/api/');

      // 那个接口需要忽略请求
      if (token && !config.url.includes('/wechat/qrcode-login')) {
        config.headers = {
          Authorization: "Bearer " + token || "",
        };
      };
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  React.$request = request;

  return new Promise((resolve, reject) => {
    resolve();
  });
}

export { axiosConfig };
